// extracted by mini-css-extract-plugin
export default {"learnContainer":"Learn_learnContainer__xnLOZ","mainContent":"Learn_mainContent__PZ7Bt","learnMain":"Learn_learnMain__+zDJv"};